import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    investData: {
        selectedItems: [],
        investAmount: ""
    }
};

const investSlice = createSlice({
    name: 'invest',
    initialState,
    reducers: {
        setInvestData: (state, action) => {
            console.log("===============action",action)
            state.investData = {
                ...state.investData,
                ...action.payload
            }
        },

    },
});

export const { setInvestData } = investSlice.actions;

export default investSlice.reducer;
